module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_6000.18716de0.png";